import { $host } from ".";

export const fetchBookings = async () => {
    try {
        const { data } = await $host.get('api/booking');
        return data;
    } catch (error) {
        console.error("Error fetching bookings:", error);
        return error;
    }
}

export const fetchBooking = async (id) => {
    try {
        const { data } = await $host.get('api/booking/id/' + id);
        return data;
    } catch (error) {
        console.error("Error fetching booking:", error);
        return error;
    }
}

export const updateBooking = async (id, booking) => {
    try {
        const { data } = await $host.put('api/booking/' + id, booking);
        return data;
    } catch (error) {
        console.error("Error updating bookings:", error);
        return error;
    }
}

export const createBooking = async (booking) => {
    try {
        const { data } = await $host.post('api/booking', booking);
        return data;
    } catch (error) {
        console.error("Error creating bookings:", error);
        return error;
    }
}

export const deleteBooking = async (id) => {
    try {
        const { data } = await $host.delete('api/booking/' + id);
        return data;
    } catch (error) {
        console.error("Error deleting booking:", error);
        return error;
    }
}
